import { useSelector } from "react-redux";
import { selectClientWallet } from "../store/auth/selectors";

export function useClientWallet() {
  return useSelector(selectClientWallet);
}
